export const employmentTypeOptions = [
  { value: 'full_time', label: 'Full-time' },
  { value: 'part_time', label: 'Part-time' },
  { value: 'probation', label: 'Probation' },
];

const entityEmploymentTypeOptions = {
  'campus-kayilan': [{ value: 'observation', label: 'Observation' }],
};

export const getEmploymentTypeOptions = (entityCode) => [
  ...employmentTypeOptions,
  ...(entityEmploymentTypeOptions[String(entityCode || '').trim().toLowerCase()] || []),
];

export const workArrangementOptions = [
  { value: 'on_site', label: 'On-site' },
  { value: 'off_site', label: 'Off-site' },
  { value: 'remote', label: 'Remote' },
];

const labelFor = (options, value) => options.find((option) => option.value === value)?.label || 'Not set';

export const getEmploymentTypeLabel = (value) => labelFor(
  [...employmentTypeOptions, ...Object.values(entityEmploymentTypeOptions).flat()],
  value
);
export const getWorkArrangementLabel = (value) => labelFor(workArrangementOptions, value);
